import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function NavBar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navLinks = [{
    label: 'Home',
    href: '#home'
  }, {
    label: 'Research',
    href: '#research'
  }, {
    label: 'How It Works',
    href: '#how-it-works'
  }, {
    label: 'Testimonials',
    href: '#testimonials'
  }, {
    label: 'FAQ',
    href: '#faq'
  }];
  return <nav className="fixed top-0 left-0 right-0 h-[60px] md:h-[60px] bg-white z-[100] border-b-2" style={{
    borderColor: '#1B4F9E',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }} data-id="element-88">
      <div className="max-w-7xl mx-auto h-full px-6 flex items-center justify-between" data-id="element-89">
        {/* Logo - centered absolutely */}
        <div className="absolute left-1/2 -translate-x-1/2 flex items-center" data-id="element-90">
          <a href="https://VitaleneHealth.com" target="_blank" rel="noopener noreferrer" data-id="element-91">
            <img src="https://cdn.magicpatterns.com/uploads/14KSRWJ2z5tGcGSSnPUYhW/LOGO_PNG.png" alt="Vitalene" className="h-8 w-auto" data-id="element-92" />
          </a>
        </div>

        {/* Desktop Nav Links */}
        <div className="hidden md:flex items-center gap-8 ml-auto" data-id="element-93">
          {navLinks.map(link => <a key={link.label} href={link.href} className="text-base font-medium transition-colors duration-200 hover:text-[#1B4F9E]" style={{
          color: '#2C3E50'
        }} data-id="element-94">
              {link.label}
            </a>)}
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle mobile menu" data-id="element-95">
          {mobileMenuOpen ? <XIcon className="w-6 h-6" style={{
          color: '#2C3E50'
        }} data-id="element-96" /> : <MenuIcon className="w-6 h-6" style={{
          color: '#2C3E50'
        }} data-id="element-97" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="md:hidden bg-white border-t border-gray-200 shadow-lg" data-id="element-98">
          <div className="px-6 py-4 flex flex-col gap-4" data-id="element-99">
            {navLinks.map(link => <a key={link.label} href={link.href} className="text-base font-medium py-2" style={{
          color: '#2C3E50'
        }} onClick={() => setMobileMenuOpen(false)} data-id="element-100">
                {link.label}
              </a>)}
          </div>
        </div>}
    </nav>;
}